import React, { Suspense, useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { theme } from './styles/theme';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import Benefits from './components/Benefits/Benefits';
import Footer from './components/Footer/Footer';
import GlobalStyles from './styles/GlobalStyles';
import FloatingDecoration from './components/common/FloatingDecoration';
import { ScrollNavigator, setReturnPoint } from './components/common/ScrollNavigator';
import CookieConsent from './components/common/CookieConsent';
import { LoadingSpinner } from './components/common/LoadingSpinner';
import { createGlobalStyle } from 'styled-components';
import { SpeedInsights } from "@vercel/speed-insights/react"
import ActivityFeed from './components/common/ActivityFeed';

// Ленивая загрузка компонентов
const Roadmap = React.lazy(() => import('./components/Roadmap/Roadmap'));
const Stats = React.lazy(() => import('./components/Stats/Stats'));
const Social = React.lazy(() => import('./components/Social/Social'));
const Partners = React.lazy(() => import('./components/Partners/Partners'));
const Gifts = React.lazy(() => import('./components/Gifts/Gifts'));

// Юридические страницы загружаем отдельно
const TermsOfUse = React.lazy(() => import('./components/legal/TermsOfUse'));
const PrivacyPolicy = React.lazy(() => import('./components/legal/PrivacyPolicy'));
const CookiePolicy = React.lazy(() => import('./components/legal/CookiePolicy'));

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #F8F9FA;
  }
`;

// Создаем отдельный компонент для контента, который будет использовать хуки роутера
const AppContent = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Routes>
        <Route path="/" element={
          <div style={{ width: '100%', overflow: 'hidden', position: 'relative' }}>
            <Header />
            <Hero />
            <FloatingDecoration />
            <Benefits />
            <Suspense fallback={<LoadingSpinner />}>
              <Roadmap />
            </Suspense>
            <Suspense fallback={<LoadingSpinner />}>
              <Stats />
            </Suspense>
            <Suspense fallback={<LoadingSpinner />}>
              <Gifts />
            </Suspense>
            <Suspense fallback={<LoadingSpinner />}>
              <Partners />
            </Suspense>
            <Social />
            <Footer />
            <ScrollNavigator />
          </div>
        } />
        <Route path="/terms" element={
          <Suspense fallback={<LoadingSpinner />}>
            <TermsOfUse />
          </Suspense>
        } />
        <Route path="/privacy" element={
          <Suspense fallback={<LoadingSpinner />}>
            <PrivacyPolicy />
          </Suspense>
        } />
        <Route path="/cookie-policy" element={
          <Suspense fallback={<LoadingSpinner />}>
            <CookiePolicy />
          </Suspense>
        } />
      </Routes>
      <CookieConsent />
      <ActivityFeed />
    </>
  );
};

// Основной компонент App
function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <GlobalStyles />
        <AppContent />
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App; 